import { type Event } from "../../types/types.ts"

// Client-side only: the grid already holds every event for the visible
// range, so filtering here needs no request per keystroke. The separate
// autocomplete box (CalendarFiltersSearch) still hits the server, since it
// searches beyond the loaded range — this only narrows what's on screen.
export const eventMatchesSearch = (event: Event, query: string): boolean => {
  const q = query.trim().toLowerCase()
  if (!q) return true

  const haystack = [
    event?.title,
    event?.lead?.name,
    event?.project?.name,
    event?.contact?.customer_name,
    event?.address,
    ...(event?.participants?.map((p) => p?.full_name) || [])
  ]

  return haystack.some((value) => value?.toLowerCase()?.includes(q))
}
